import { DateTime } from 'luxon'
import moment from 'moment'

export function isoDateToFormDate(iso, zone = 'local') {
  return DateTime.fromISO(iso, { zone: zone })
    .set({ second: 0, millisecond: 0 })
    .toISO({
      includeOffset: false,
      suppressMilliseconds: true,
      suppressSeconds: true
    })
}

export function isoDateFromFormDate(iso, zone = 'local') {
  if (zone === 'local') {
    return DateTime.fromISO(iso, { zone: 'local' }).toUTC().toISO({
      includeOffset: true,
      suppressMilliseconds: true
    })
  }
  return DateTime.fromISO(iso, { zone: zone }).toISO({
    includeOffset: true,
    suppressMilliseconds: true
  })
}

export function usDateToFormDate(us) {
  return isoDateToFormDate(moment(us, 'MM/DD/YYYY, hh:mm A').toISOString())
}

export function cleanDate(date) {
  if (date == '0001-01-01T12:00:00+00:00') {
    return null
  } else if (parseInt(DateTime.fromISO(date).year) < 1900) {
    return null
  } else {
    return date
  }
}

export function zeroPad(value) {
  const stringValue = typeof value === 'number' ? value.toString() : value
  return stringValue.length < 2 ? '0' + stringValue : stringValue
}

export function yearPad(value) {
  const stringValue = typeof value === 'number' ? value.toString() : value
  return stringValue.length < 3 ? '20' + zeroPad(stringValue) : stringValue
}
